import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "submit"]

  connect() {
    this.toggleSubmit()
  }

  updateAction() {
    this.element.action = this.selectTarget.value
    this.toggleSubmit()
  }

  toggleSubmit() {
    this.submitTarget.disabled = !this.selectTarget.value
  }
}
